import React from 'react';
import {useNavigate} from 'react-router-dom';
import Hero from '../components/Hero';
import TrustBanner from '../components/TrustBanner';
import HowItWorks from '../components/HowItWorks';
import Calculator from '../components/Calculator';
import TreatmentList from '../components/TreatmentList';
import Testimonials from '../components/Testimonials';
import {HomeFaq} from './FAQ';

export default function Home() {
  const navigate=useNavigate();

  return (
    <>
      <Hero />
      <TrustBanner />
      <HowItWorks />
      <Calculator />
      <TreatmentList />
      <Testimonials />
      <HomeFaq />
      <section className="relative overflow-hidden border-t border-slate-100 bg-white py-32 text-center">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-50/50" />
        <div className="relative z-10 mx-auto max-w-3xl px-4">
          <h2 className="mb-6 text-4xl font-extrabold tracking-tight text-slate-900 md:text-5xl">Ready to get started?</h2>
          <p className="mb-10 text-xl leading-relaxed text-slate-600">
            Explore convenient telehealth options designed around your goals.
          </p>
          <button onClick={()=> navigate('/weightquiz')} className="transform rounded-full bg-slate-900 px-10 py-5 text-lg font-bold text-white shadow-2xl transition-all duration-300 hover:-translate-y-1 hover:bg-teal-600 hover:shadow-teal-600/30">
            Explore Treatments
          </button>
        </div>
      </section>
    </>
  );
}